import { Button, Chip, CircularProgress, Grid  } from '@mui/material';
import { useEffect, useState } from 'react';

import { gridSizeMdLg12, gridSizeMdLg6 } from '@/shared';
import {
  getRadiusRadReply,
  SingleRadiusObject,
  useFetchGetBras,
  usePostEstadoRadiusCliente,
} from '@/shared/actions/erp';
import {
  CustomAutocompleteNoForm,
  CustomTextFieldNoForm,
} from '@/shared/components/ui';
import { ScrollableDialogProps } from '@/shared/components/ui/Dialogs';
import TrazabilidadLogFormTab from '@/erp/clientes/fibra-optica/shared/components/form/trazabilidad-log/TrazabailidadLogFormTab';
import { IBras } from '@/shared/interfaces/erp/configuracion-red/bras/bras.interface';
// import { useQueryClient } from '@tanstack/react-query';
import { Refresh } from '@mui/icons-material';
import { toast } from 'react-toastify';
export type DetallesDeConsumoClienteModalProps = {
  open: boolean;
  onClose: () => void;
  username: string
  password: string
};

type EstadoEnBras = "Online"|"Offline"


const DetallesDeConsumoClienteModal: React.FC<
  DetallesDeConsumoClienteModalProps
> = ({ onClose, open, username, password="" }) => {

  // const queryClient = useQueryClient();
  ///* hooks ------------------------
  const [loadButtonRefresh, setLoadButtonRefresh] = useState<boolean>(false);
  const [dataRadReply, setdataRadReply] = useState<SingleRadiusObject[]|null>(null);
  const [estadoEnBrasValue, setEstadoEnBrasValue] = useState<EstadoEnBras|null>(null);

  ///* global state ------------------------
  // const setAlert = useUiStore(s => s.setAlert);
  
  const {
    data: dataBras,
    isLoading: isLoadingBras
  } = useFetchGetBras({
    enabled:true,
    params:{
      estado:true
    }
  })
  const {
    mutateAsync:mutateEstadoRadiusCliente,
    isPending:isPendingEstadoRadiusCliente,
    error:errorEstadoRadiusCliente,
  } = usePostEstadoRadiusCliente({
    customMessageErrorAlert:"Error al consultar estado en radius",
    enableSuccessAlert:true,
  })
  ///* handlers ------------------------

  const handleClose = () => {
    setdataRadReply(null)
    onClose();
  };
  const radReply = async(username:string) => {
    setLoadButtonRefresh(true)
    const dataRadReply = await getRadiusRadReply({username:username})
    const dataDomainRadReply: SingleRadiusObject[] =  dataRadReply?.data
    if(dataDomainRadReply.length==0){
      toast.warning("No existen datos del Rad Reply")
    }
    setdataRadReply(dataDomainRadReply)
    setTimeout(() => {
      setLoadButtonRefresh(false)
    }, 1000);
  }

  const consultarEstadoEnBras = async (bras_data:IBras) => {
    const dataEstadoRadiusCliente = await mutateEstadoRadiusCliente({server_id:bras_data.modelo!, pppoe:username })
    return dataEstadoRadiusCliente
  }

  ///* effects ------------------------
  useEffect(() => {
    if(!!username && open){
      radReply(username)
      // setEstadoEnBrasValue(consultarEstadoEnBras({} as IBras,username))
    }
  }, [username, open]);

  if (!open) return null;

  return (
    <ScrollableDialogProps
      open={open}
      title={`Detalles del Consumo`}
      minWidth="70%"
      contentNode={
        <Grid  {...gridSizeMdLg12} container spacing={3} alignItems="center">
          <Grid {...gridSizeMdLg12} item container spacing={2}>
            <Grid container item >
              {
                loadButtonRefresh?
                <CircularProgress/>
                :
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    radReply(username)
                  }}
                  endIcon={<Refresh/>}
                >
                  Refrescar
                </Button>
              }
            </Grid>
          </Grid>
          <CustomTextFieldNoForm
            label="PPPoE"
            value={username || dataRadReply?.[0]?.username}
            shrink
            disabled
            size={gridSizeMdLg6}
          />
          <CustomTextFieldNoForm
            label="ID Huawei-Domain-Name"
            value={dataRadReply?.[1]?.attribute}
            shrink
            disabled
            size={gridSizeMdLg6}
          />
          <CustomTextFieldNoForm
            label="Password"
            value={password}
            shrink
            disabled
            size={gridSizeMdLg6}
          />
          <CustomTextFieldNoForm
            label="ID Framed-IP-Address"
            value={dataRadReply?.[0]?.value}
            shrink
            disabled
            size={gridSizeMdLg6}
          />
          <CustomTextFieldNoForm
            label="Value"
            value={dataRadReply?.[1]?.value}
            shrink
            disabled
            size={gridSizeMdLg6}
          />
          <Grid {...gridSizeMdLg6} container item spacing={1}>
            <CustomAutocompleteNoForm<IBras>
              label="Consultar Estado en Bras"
              //name="label"
              options={dataBras?.data?.data||[]}
              valueKey={'nombre'}
              actualValueKey={'codigo'}
              defaultValue={''}
              isLoadingData={isLoadingBras}
              onChangeRawValue={async (value) => {
                if(!value){
                  return setEstadoEnBrasValue(null)
                }
                if(!value.modelo){
                  return toast.error("El BRAS seleccionado no cuenta con modelo.")
                }
                setEstadoEnBrasValue((await consultarEstadoEnBras(value)).data.status)
              }}
              size={gridSizeMdLg6}
            />
            <Grid {...gridSizeMdLg6} container justifyContent={"center"} alignContent={"center"}>
              {
                isPendingEstadoRadiusCliente?
                <CircularProgress /> 
                :!errorEstadoRadiusCliente?
                <Chip label={estadoEnBrasValue||"Seleccione un BRAS"} 
                color={estadoEnBrasValue=="Online"?
                  "success"
                  :estadoEnBrasValue=="Offline"?"error":"info"
                }
                sx={{
                  padding:3
                }}
                variant="filled" />
                :<Chip label={"Error al consultar estado en BRAS"} 
                color={"error"}
                sx={{
                  fontSize:20,
                  padding:3
                }}
                variant="filled" />
              }
            </Grid>

          </Grid>
          {/* <CustomTextFieldNoForm
            label="Huawei-Domain-Name Value"
            value={dataRadReply?.[1]?.value}
            shrink
            disabled
            size={gridSizeMdLg6}
          /> */}
          {/* <CustomTextFieldNoForm
            label="Attribute"
            value={dataRadReply?.attribute}
            shrink
            disabled
            size={gridSizeMdLg6}
          /> */}
          {/* <CustomTextFieldNoForm
            label="OP"
            value={dataRadReply?.[0]?.op}
            shrink
            disabled
            size={gridSizeMdLg6}
          /> */}
          
          
          
          <Grid item {...gridSizeMdLg12}>
            <TrazabilidadLogFormTab
              contract={{pppoe:username||dataRadReply?.[0]?.username}}
            />
          </Grid>
        </Grid>
      }
      onClose={handleClose}
      showConfirmBtn={false}
      cancelTextBtn='Regresar'
    />
  );
};

export default DetallesDeConsumoClienteModal;
